var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CsTeleport,[_c(_setup.CsTransitionRoot,{staticClass:"relative z-[var(--modal-z-index)]",style:({
      '--modal-z-index': _setup.props.zIndex,
    }),attrs:{"is-open":_vm.isOpen,"data-component":"CsModal","data-slot":"root","role":"dialog"}},[_c(_setup.CsModalBackdrop),_vm._v(" "),_c(_setup.CsModalPanel,{attrs:{"size":_setup.props.size,"enable-vertical-scroll":_setup.props.enableVerticalScroll}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }